import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "customer-detail-section" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "customer-detail-inner" }
const _hoisted_6 = { class: "customer-detail-sidebar" }
const _hoisted_7 = { class: "customer-logo" }
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "short-details" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "related-case-study" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "customer-detail-content" }
const _hoisted_16 = { class: "c_d_des" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "case-study-slider" }
const _hoisted_19 = {
  id: "carouselExampleIndicators",
  class: "carousel slide",
  "data-bs-ride": "carousel"
}
const _hoisted_20 = { class: "carousel-inner" }
const _hoisted_21 = { class: "carousel-item active" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { class: "case-study-tabs" }
const _hoisted_24 = {
  class: "case-study-tabs--btm tab-content",
  id: "myTabContent"
}
const _hoisted_25 = {
  class: "tab-pane fade show active",
  id: "taba",
  role: "tabpanel",
  "aria-labelledby": "tab-a"
}
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = {
  class: "tab-pane fade",
  id: "tabb",
  role: "tabpanel",
  "aria-labelledby": "tab-b"
}
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  class: "tab-pane fade",
  id: "tabc",
  role: "tabpanel",
  "aria-labelledby": "tab-c"
}
const _hoisted_30 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_userFooter = _resolveComponent("userFooter")!
  const _component_ChatbotPopup = _resolveComponent("ChatbotPopup")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Case Study", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _ctx.getCdnImageAddress(_ctx.clientData.companyLogo, `w_248,h_202/`),
                  alt: _ctx.clientData.title
                }, null, 8, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", { innerHTML: _ctx.truncatedDescription }, null, 8, _hoisted_10)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Related Case Studies", -1)),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relatedCaseStudies, (relatedClient) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: relatedClient.id
                    }, [
                      (_ctx.shouldShowClientReadMore(relatedClient))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("a", {
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.navigateToClient(relatedClient.slug)), ["prevent"])
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.getCdnImageAddress(relatedClient.companyLogo, `w_120,h_98/`),
                                alt: relatedClient.title
                              }, null, 8, _hoisted_14)
                            ], 8, _hoisted_13)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.clientData.title), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", {
                  innerHTML: _ctx.clientData.description
                }, null, 8, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("img", {
                        src: _ctx.getCdnImageAddress(_ctx.clientData.companyImage, `w_719,h_429/`),
                        alt: _ctx.clientData.title
                      }, null, 8, _hoisted_22)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "case-study-tabs--top" }, [
                  _createElementVNode("ul", {
                    class: "nav",
                    id: "myTab",
                    role: "tablist"
                  }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        class: "active",
                        id: "tab-a",
                        "data-bs-toggle": "tab",
                        href: "#taba",
                        role: "tab",
                        "aria-controls": "taba",
                        "aria-selected": "true"
                      }, "Challenge")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        id: "tab-b",
                        "data-bs-toggle": "tab",
                        href: "#tabb",
                        role: "tab",
                        "aria-controls": "tabb",
                        "aria-selected": "false"
                      }, "Solutions")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("a", {
                        id: "tab-c",
                        "data-bs-toggle": "tab",
                        href: "#tabc",
                        role: "tab",
                        "aria-controls": "tabc",
                        "aria-selected": "false"
                      }, "Result")
                    ])
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("p", {
                      innerHTML: _ctx.clientData.challenge
                    }, null, 8, _hoisted_26)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", {
                      innerHTML: _ctx.clientData.solution
                    }, null, 8, _hoisted_28)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", {
                      innerHTML: _ctx.clientData.result
                    }, null, 8, _hoisted_30)
                  ])
                ])
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "clear" }, null, -1))
          ])
        ])
      ])
    ]),
    _createVNode(_component_userFooter),
    _createVNode(_component_ChatbotPopup)
  ]))
}